<template>
  <el-row>
    <el-col :span="8"><div class="grid-content bg-purple" style="margin: 2em 0;"></div></el-col>
    <el-col :span="8"><div class="grid-content bg-purple-light">
      <el-card class="box-card">
        <div slot="header" class="clearfix text-left">
          <h4>Zusammenfassung</h4>
        </div>
        <div class="text-left">
          <p><strong>Mandant:</strong> {{ surveyResponse.customer_name }}</p>
          <p><strong>Betreff:</strong> TOMs Audit</p>
          <p><strong>TOMs:</strong> <a :href="downloadBaseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_toms" class="FileLink">{{ surveyResponse.customer_name }}_Toms_Bericht.docx</a></p>
          <p><strong>Auditbericht:</strong> <a :href="downloadBaseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_audit" class="FileLink">{{ surveyResponse.customer_name }}_Auditbericht.docx</a></p>
          <p><strong>Todo-Liste:</strong> <a :href="downloadBaseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url_todos" class="FileLink">{{ surveyResponse.customer_name }}_To-do_list.docx</a></p>
          <p><strong>Datum:</strong> {{ surveyResponse.createdon }}</p>
        </div>
      </el-card>
    </div>
      <div style="margin: 50px auto"></div>
      <div>
        <p><strong>Bericht in PDF erstellen</strong></p>
        <el-upload
          class="upload-demo"
          v-loading="loading"
          :data = "{'contract_path': surveyResponse.document_url, 'customer_name': surveyResponse.customer_name}"
          action="https://h2822595.stratoserver.net/generate_pdf_report/"
          :on-success="showURL">
          <el-button size="small" type="primary">Click to upload</el-button>
          <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 500kb</div>
        </el-upload>
        <div v-show="pdfURL">
          <p><strong>Bericht:</strong> <a :href="downloadBaseURL + '/survey/v1/download/?filename=' + downloadURL">{{ surveyResponse.customer_name }}_{{ surveyResponse.document_url }}.docx</a></p>
        </div>
      </div>
    </el-col>
    <el-col :span="8"><div class="grid-content bg-purple" style="margin: 2em 0;"></div></el-col>
  </el-row>
</template>
<script>
import { baseURL } from '@/utils/request'
export default {
  name: 'ConfirmTOMs',
  data() {
    return {
      pdfURL: false,
      downloadURL: '',
      loading: false,
      downloadBaseURL: baseURL
    }
  },
  props: ['surveyResponse'],
  methods: {
    showURL: function(response) {
      this.pdfURL = true
      this.downloadURL = response
    }
  }
}
</script>

<style scoped>
.FileLink {
  color: blue;
}
</style>
